<template>
  <div class="contest" v-if="contest">
    <div class="title">
      <h3 v-if="contest && contest.title && contest.title[lang]" @click="handleView">{{ contest.title[lang] }}</h3>
      <vue-dropdown class="actions" :actions="actions" @action="action"></vue-dropdown>
    </div>
    <div v-if="contest && contest.title && contest.title[lang]" class="description" @click="handleView">
      <p>{{ contest.description[lang] }}</p>
    </div>
    <div v-if="contest && contest.datestart" class="datestart">
      <p>From: {{ contest.datestart.slice(0, contest.datestart.indexOf('T')) }}</p>
    </div>
    <div v-if="contest && contest.dateend" class="dateend">
      <p>To: {{ contest.dateend.slice(0, contest.dateend.indexOf('T')) }}</p>
    </div>
    <contest-integration :id="id" v-if="isIntegrationOpened" @close="isIntegrationOpened = false"></contest-integration>
    <contest-form
      :id="id"
      v-if="isEditionOpened"
      :open="isEditionOpened"
      @close="isEditionOpened = false"
    ></contest-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueDropdown from '@kevindesousa/vue-dropdown'
import ContestIntegration from '@/components/contests/contest-integration.vue'
import ContestForm from '@/components/contests/contest-form.vue'

export default {
  name: 'contest-card',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  components: { VueDropdown, ContestIntegration, ContestForm },

  data() {
    return {
      isIntegrationOpened: false,
      isEditionOpened: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('contest', {
      getById: 'getById'
    }),

    contest() {
      return this.getById(this.id)
    },

    actions() {
      return [
        {
          title: 'Edit',
          action: 'edit',
          icon: null
        },
        {
          title: 'Integration',
          action: 'integration',
          icon: null
        },
        {
          title: 'Delete',
          action: 'delete',
          icon: null
        }
      ]
    }
  },

  methods: {
    ...mapActions('contest', ['removeContest']),

    action(action) {
      switch (action) {
        case 'edit':
          this.isEditionOpened = true
          break
        case 'integration':
          this.isIntegrationOpened = true
          break
        case 'delete':
          this.handleDelete()
          break
        default:
          break
      }
    },

    handleView() {
      this.$router.push('/' + this.site.sitekey + '/contests/' + this.id)
    },

    handleDelete() {
      this.removeContest({ contest: this.contest, sitekey: this.site.sitekey })
        .then(() => {
          this.$notify({ title: 'Success', message: this.$root.$t('notifications.contest.deleted'), type: 'success' })
        })
        .catch(() => {
          this.$notify.error({ tittle: 'Error', message: this.$root.$t('notifications.unknown') })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.contest {
  display: flex;
  flex-direction: column;
  padding: 18px;
  box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: white;

  .title {
    display: grid;
    min-height: 24px;
    align-items: center;
    grid-template-columns: 1fr 20px;
    h3 {
      font-size: 18px;
      font-weight: -00;
      margin: 0;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .description {
    flex: 1;
    p {
      margin: 4px 0 8px;
    }
  }

  &:hover {
    box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contests/contest-card.vue